




























import Vue from 'vue';
import NOC from '@/class/common/const';
import * as models from '@/class/models/views/app';
import VariableInput, * as vi from '@/components/util/VariableInput.vue';

export default Vue.extend({
  name: 'Change',
  components: { VariableInput },
  props: {
    error : Object,
  },
  data() {
    return {
      showModal: false,
      accountData: new models.CAuth(),
      items: [
        {key: 'code', name: 'コード', type: vi.INPUT_TYPE.TEXT, placeholder: 'コード', required: true, checks: [], error: '', max: 40 },
        {key: 'mail', name: 'メールアドレス', autoComplete: null, type: vi.INPUT_TYPE.TEXT, placeholder: '登録中のメールアドレス', required: true, checks: [vi.CHECK_TYPE.EMAIL], error: '', max: 40 },
        {key: 'password', name: '新しいパスワード', autoComplete: 'new-password' , type: vi.INPUT_TYPE.PASSWORD, placeholder: '新しいパスワード', required: true, checks: [vi.CHECK_TYPE.PASSWORD], error: '', max: 40 },
        // {key: 'passwordConfirm', name: '新しいパスワード(確認用)', type: vi.INPUT_TYPE.PASSWORD, placeholder: '新しいパスワード（確認用）', required: true, checks: [vi.CHECK_TYPE.PASSWORD], error: '', min: 8, max: 40 },
      ] as vi.IVariableInput[],
      dispToggleInputs: [
        'password',
        'passwordConfirm',
      ],
      dispToggles: {
        password: 'password',
        passwordConfirm: 'password',
      },
    };
  },
  computed: {
    APP_MODE() { return NOC.APP.MODE; },
  },
  watch: {
    error: {
      deep: true,
      handler(newValue: any) {
        const target = this.items.filter((v) => (v.key === newValue.key));
        target[0].error = newValue.error;
      },
    },

    // accountData: {
    //   deep: true,
    //   handler(newValue: any) {
    //     const mailVal = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    //     if(mailVal.test(newValue['code'])){
    //       this.accountData.mail = newValue['code'];
    //       this.accountData.code='';
    //       console.log(this.accountData['code']);
    //      vi.checkValues(this.accountData,this.items);
    //      this.items[1].error = '';
    //      console.log(this.items[1]);
    //     }
    //   },
    // }

  },
  methods: {
    dispToggle(input: string) {
      if (input !== 'password' && input !== 'passwordConfirm') { // コンパイルエラー回避
        return;
      }
      const el = document.querySelector('#' + input + '-input input') as any;

      if (el.type === 'text') {
        el.type = 'password';
        this.dispToggles[input] = 'password';
      } else {
        el.type = 'text';
        this.dispToggles[input] = 'text';
      }
    },
    onClickChange() {
      // vallidation check
      if (vi.checkValues(this.accountData, this.items) > 0) {
        return;
      }
      const validPassword = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d]{8,40}$/;
      // パスワードが正規表現と一致しない場合
      if (!validPassword.test(this.accountData.password)) {
        this.items[2].error = '半角大小英数字を1文字ずつ含む8文字以上40字以内';
        return;
      }
      this.$emit('changePass', this.accountData);
    },
  },
});
